import { ChecklistItemRecord } from "models/view-models/block-configurations/checklist-item-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface SharedChecklistBlockConfigurationChecklistItemsPathParams {
    pageGuid: string;
    configurationId: number;
}

export interface SharedChecklistBlockConfigurationChecklistItemsQueryParams {
    recipient?: string;
}

const resourceEndpoint: string =
    "public/pages/:pageGuid/blocks/configurations/checklist/:configurationId/checklistItems";

const resourceType = ChecklistItemRecord;

const SharedChecklistBlockConfigurationChecklistItemService = {
    useNestedList: ServiceHookFactory.useNestedList<
        ChecklistItemRecord,
        SharedChecklistBlockConfigurationChecklistItemsPathParams,
        SharedChecklistBlockConfigurationChecklistItemsQueryParams
    >(resourceType, resourceEndpoint),
};

export default SharedChecklistBlockConfigurationChecklistItemService;
